import { gql } from "apollo-angular";

export const CREATE_PROFILE = gql`
  mutation createRole( $createRoleInput: CreateProfileInput!) {
    createRole(createRoleInput: $createRoleInput) 
    {
    id
    profileName
  }
}
`;

export const ACTIVATE_OR_DEACTIVATE = gql`
  mutation activateOrDeactivateUser( $userId: Int!, $status: Int!) {
    activateOrDeactivateUser(userId: $userId, status: $status) 
    {
    id
    email
    password
    firstName
    lastName
    status
    resetToken
    profileId
    branchIds
  }
}
`;

export const UPDATE_PERMISSIONS = gql`
  mutation assignBulkPermissions( $input: BulkPermission!) {
    assignBulkPermissions(input: $input) 
}
`;

// export const UPDATE_PERMISSIONS = gql`
//   mutation assignBulkPermissions( $profileId: Int!, $modules: [ModulePermissionInput!]!) {
//     assignBulkPermissions(profileId: $profileId, modules: $modules) 
// }
// `;

export const REMOVE_PROFILE = gql`
  mutation removeProfile( $id: Int!) {
    removeProfile(id: $id) 
}
`;

export const CLONE_PROFILE = gql`
  mutation cloneProfile( $profileId: Int!, $profileName: String!, $description: String!) {
    cloneProfile(profileId: $profileId, profileName: $profileName, description: $description) 
    {
    id
    profileName
    description
    rolePermissions {
      id
      profileId
      profileName
      moduleId
      permissionId

      status
    }

  }
}
`;